import i18n from '../../i18n';

const CareersSkillsData = [
    {
        id: 1,
        title: i18n.t('data2.expSelectTitle'),
        experience: i18n.t('data2.expSelect'),
        skills: []
    },
    {
        id: 2,
        title: i18n.t('data2.roleAssocDev'),
        experience: i18n.t('data2.expFresher'),
        skills: ["C", "C++", "Oops", "DS", "Python", "Java"]
    },
    {
        id: 3,
        title: i18n.t('data2.roleAssocDev'),
        experience: i18n.t('data2.exp06to1'),
        skills: ["C", "C++", "Oops", "DS", "Python"]
    },
    {
        id: 4,
        title: i18n.t('data2.roleAssocDev'),
        experience: i18n.t('data2.exp1to2'),
        skills: ["C", "C++", "Oops", "DS", "Qt", "Qml"]
    },
    {
        id: 5,
        title: i18n.t('data2.roleSrAssocDev'),
        experience: i18n.t('data2.exp2to4'),
        skills: ["C", "C++", "Oops", "DS", "Qt", "Qml"]
    },
    {
        id: 6,
        title: i18n.t('data2.roleTechLead'),
        experience: i18n.t('data2.exp4to6'),
        skills: ["C", "C++", "Modern C++", "Qt", "Qml"]
    },
    {
        id: 7,
        title: i18n.t('data2.roleSrTechLead'),
        experience: i18n.t('data2.exp6to10'),
        skills: ["C", "C++", "Modern C++", "Qt", "Qml", "Qt 3D"]
    },
    {
        id: 8,
        title: i18n.t('data2.roleArchitect'),
        experience: i18n.t('data2.exp10plus'),
        skills: ["C", "C++", "Modern C++", "Qt", "Qml", "Qt 3D", "OpenGL", "ADAS", "AUTOSAR"]
    }
];

export default CareersSkillsData;